import { render } from "./ScanAttendance.vue?vue&type=template&id=f9b28ff2"
import script from "./ScanAttendance.vue?vue&type=script&lang=js"
export * from "./ScanAttendance.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__